<p-confirmDialog />
<h3 class="with-manual-link">
  <span i18n="@@knowlede-databases">Bot-Wissensdatenbanken</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Skills/Datenbanken"></app-manual-link>
</h3>
<p
  class="text-secondary mt-1 mb-1"
  i18n="@@knowlede-databases-description"
>
  Eine einfache Schlüssel-Wert-Liste als Wissensbasis: Wird ein Schlüssel erkannt, wird der zugehörige Wert dem LLM als
  Kontext übergeben.
</p>
<div>
  <div class="row">
    <div class="col-3">
      <span i18n="@@use-of-database">Verwendungszweck der Datenbank</span>
    </div>
    <div class="col">
      <p-inputgroup>
        <p-inputgroup-addon>
          <i
            class="ri-sparkling-fill text-primary"
            style="font-size: 1.2rem;"
          ></i>
        </p-inputgroup-addon>
        <input
          pInputText
          placeholder=""
          [(ngModel)]="this.newDatabaseDescription"
          [ngModelOptions]="{updateOn: 'change'}"
          fluid
        >
      </p-inputgroup>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3"></div>
    <div class="col-3">
      <p-button
        severity="primary"
        size="small"
        [disabled]="this.checkForAdding()"
        (onClick)="this.addDatabase()"
      >
        <i class="ri-add-line"></i>
        <span i18n="@@create-database">Datenbank anlegen</span>
      </p-button>
    </div>
  </div>
</div>
@if (this.rss.datatrunks.length > 0) {
<h5
  class="mt-5"
  i18n="@@configured-databases-overview"
>Konfigurierte KI-Datenbanken im Überblick</h5>
}

@if (this.rss.datatrunks.length > 0) {
<p-table
  dataKey="_id"
  [(selection)]="selectedTrunks"
  [value]="this.rss.datatrunks"
  [rowHover]="true"
  styleClass="p-datatable-sm"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="bot-selection-cell"><p-tableHeaderCheckbox ariaLabel="Alle auswählen" i18n-ariaLabel="@@bulk-select-all" /></th>
      <th i18n="@@status">Status</th>
      <th i18n="@@use-of-database">Verwendungszweck der Datenbank</th>
      <th i18n="@@functionname">Funktionsname</th>
      <th i18n="@@skillid">Skill ID</th>
      <th i18n="@@skill-usage-column">Stage-Zuordnung</th>
      <th i18n="@@onoff">Aus/An</th>
      <th i18n="@@actions">Aktionen</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-trunk
  >
    <tr>
      <td class="bot-selection-cell"><p-tableCheckbox [value]="trunk" [ariaLabel]="trunk.trunkDescription" /></td>
      <td style="width: 4rem;">
        @if (trunk.active) {
        <i class="ri-circle-fill text-primary"></i>
        }
        @if (!trunk.active) {
        <i class="ri-circle-line text-secondary"></i>
        }
      </td>
      <td>
        <span
          class="fakelink"
          (click)="showDetailDrawer(trunk._id)"
        >
          {{ trunk.trunkDescription }}
        </span>
      </td>
      <td>{{ trunk.placeholder }}</td>
      <td style="width:250px">
        <app-skill-id-input
          [value]="trunk.skillId"
          (changed)="trunk.skillId = $event; this.updateDatabase(trunk)"
        ></app-skill-id-input>
      </td>
      <td>
        <app-skill-usage-list [skillId]="trunk.skillId"></app-skill-usage-list>
      </td>
      <td style="width: 0rem;">
        <p-toggleswitch
          [(ngModel)]="trunk.active"
          (onChange)="this.updateDatabase(trunk); trunk.active ? this.counter.addTrunk(this.rss.botConfig._id) : this.counter.removeTrunk(this.rss.botConfig._id)"
        ></p-toggleswitch>
      </td>
      <td
        style="width: 2rem;"
        class="text-end"
      >
        <p-menu
          #menu
          appendTo="body"
          [model]="dataBaseContextMenu"
          [popup]="true"
        ></p-menu>
        <p-button
          (onClick)="openDatabaseMenu($event, menu, trunk)"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          [raised]="true"
          icon="ri ri-more-2-fill"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<app-bulk-action-bar [actions]="bulkActions" [count]="selectedTrunks.length" [allSelected]="allSelected"
  (selectAll)="toggleAll(true)" (clear)="selectedTrunks = []" />
}

@if (detailDrawer) {
<p-drawer
  [(visible)]="this.detailDrawer"
  [position]="'right'"
  [modal]="true"
  [closeOnEscape]="true"
  styleClass="w-100 w-md-75 w-lg-50"
>
  @if (this.selectedTrunkId) {
  <app-databases-tab-detail
    [selectedTrunkId]="this.selectedTrunkId"
    (closeDrawer)="this.detailDrawer = false"
  ></app-databases-tab-detail>
  }
</p-drawer>
}